import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ClientForm from '../../../components/forms/ClientForm';
import { useClientApi } from '../../../hooks/useClientApi';
import { useNavigate, useParams } from 'react-router-dom';
import { ClientDTO } from '../../../services/apiClient';

const ClientEdit: React.FC = () => {
  const { getById, edit } = useClientApi();
  const [entityData, setEntityData] = useState<ClientDTO | null>(null);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Clients', href: '/admin/clients' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching Client data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      await edit(id!, data);
      navigate('/admin/clients');
    } catch (error) {
      console.error('Error updating Client:', error);
    } finally{
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/clients"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.Client.Edit'
    >
        {entityData ? (
          <ClientForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/clients')}
            isLoading={isSubmitting}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default ClientEdit;